export default __webpack_public_path__ + "static/media/a03646d90609eaa484e78f5f37bfeed3.gif";